<div class="center" (click)="onClick()" data-action="clicked-redirect-banner">
  <img src="{{ imageUrl }}" alt="image" />
</div>
